import api from './api'

const cancellationPolicyService = {
  // Public — fetch the currently active version for a type.
  getActive: async (type) => {
    const response = await api.get('/policies/active', { params: { type } })
    return response.data
  },

  // Admin — list version history for a type.
  list: async (type, limit = 50) => {
    const response = await api.get('/admin/policies', { params: { type, limit } })
    return response.data
  },

  // Admin — fetch a specific version (with markdown content).
  getById: async (id) => {
    const response = await api.get(`/admin/policies/${id}`)
    return response.data
  },

  // Admin — publish a new version (deactivates the previous active row).
  publish: async (policy_type, content) => {
    const response = await api.post('/admin/policies', { policy_type, content })
    return response.data
  },
}

export default cancellationPolicyService
